import * as React from "react";
import { connect } from "react-redux";
import { Dispatch } from 'redux';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFlag, faTrashAlt, faCheckCircle, faTimesCircle, faTimes, faUserCircle, faRecycle } from '@fortawesome/free-solid-svg-icons';
import { CardImg, Container, Modal, ModalHeader, ModalBody, ModalFooter, Button, CardLink, Col, Fade, Row, Input } from "reactstrap";
import { messageBoardAction } from '../../actions/messageBoardAction';
import { showAlert, handleDownloadZip } from "../common/functions";
import moment from 'moment';
import parse from "html-react-parser";
import ReactPaginate from 'react-paginate';
import ReactReadMoreReadLess from 'react-read-more-read-less';
import { DABTextBox, DABDropDown, DABBackToList, LoadingSpinnerModal, ConfirmModal } from '../../components/dab';
import { getLoggedUserId } from '../../services/selectors/Accounts';
import Profile from '../../assets/images/user-profile.jpg'

interface IPostsProps {
	dispatch: Dispatch<any>;
	messageBoardData: any;
	id: number;
	callback: any;
}

const Posts: React.SFC<IPostsProps> = ({
	dispatch, messageBoardData, id, callback }) => {
	console.log('1', messageBoardData.alertsData)
	const [postsList, setPostsList] = useState([]);
	const [alertsList, setAlertsList] = useState([]);
	const [showModal, setShowModal] = useState(false);
	const [message, setMessage] = useState({
		author: "",
		displayName: "",
		authorId: "",
		authorImageUrl: "",
		message: "",
		messageId: 0,
		messageDate: "",
		isMessageDeleted: false,
		messageReportCount: 0,
		attachment: [""],
		uniqueCode:""
	});
	const [deleteRequest, setDeleteRequest] = useState('');
	const [isAlert, setIsAlert] = useState(false);

	const initialInputValue = {
		messageBoardId: id,
		topicId: id,
		messageId: 0,
		pageNumber: 1,
		pageSize: 5,
		sortDirection: "desc",
		isDeleted: false,
		isNotDeleted: true
	};

	const flaggingInput = {
		messageReportId: 0,
		messageReportTypeId: -1,
		messageId: 0,
		reportedByUserId: 0,
		reviewedByUserId: 0,
		reviewNote: "",
		isApprove: false
	}
	const [filterInput, setFilterInput] = useState(initialInputValue);
	const [pageList, setPageList] = useState([1]);
	const [currentPageNo, setCurrentPageNo] = useState(0);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [selectedId, setSelectedId] = useState(0);
	const [isFlagModalOpen, setIsFlagModalOpen] = useState(false);
	const [flagObject, setFlagObject] = useState(flaggingInput);
	const [reportTypeList, setReportTypeList] = useState([]);
	const [loggedUsedId, setLoggedUserId] = useState(0);
	const [isTypeErr, setIsTypeErr] = useState(false);
	const [fadeIn, setFadeIn] = useState(false);
	const [showClearFilter, setShowClearFilter] = useState(false);
	const [isDeleted, setIsDeleted] = useState(false);
	const [isNotDeleted, setIsNotDeleted] = useState(true);


	const setPageNumber = (pageNo) => {
		setFilterInput({
			...filterInput,
			pageNumber: pageNo,
		});
	};

	const handlePageClick = (data) => {
		setPageNumber(data.selected + 1);
		setCurrentPageNo(data.selected);
	};

	const handleToggle = () => setFadeIn(!fadeIn);

	const handleDownload = async () => {
		setShowModal(true)
		await handleDownloadZip(message.attachment)
		setShowModal(false)
	}


	const handleFilterClear = () => {
		setFadeIn(false);
		setFilterInput(initialInputValue);
		setShowClearFilter(false);
		setIsDeleted(false);
		setIsNotDeleted(true);
		setCurrentPageNo(0);
		sessionStorage.removeItem("PostFilter");
		sessionStorage.removeItem("postFromPage");
	}

	const handleFilter = () => {		
		setFilterInput({
			...filterInput,
			isDeleted: isDeleted,
			isNotDeleted: isNotDeleted,
			pageNumber: 1
		});
		setShowClearFilter(true);
		handleToggle();
		setCurrentPageNo(0);
	};

	const handleFilterRestore = () => {
		var filter = sessionStorage.getItem("PostFilter");
		if (filter != null && filter.trim() != "") {
			var filterObj = JSON.parse(filter.toString());
			if (filterObj != null) {
				if (id === filterObj.topicId) {
					setIsDeleted(filterObj.isDeleted);
					setIsNotDeleted(filterObj.isNotDeleted);
					setFilterInput(filterObj);
					setShowClearFilter(true);
					setCurrentPageNo(filterObj.pageNumber - 1)
				} else {
					sessionStorage.removeItem("PostFilter");
				}
			}
			sessionStorage.removeItem("postFromPage");
		}
	}

	React.useEffect(() => {
		var tokenstr = (new URLSearchParams(window.location.search))?.get("page");
		if (tokenstr === "posts") {
			var fromPage = sessionStorage.getItem("postFromPage");

			if (fromPage && fromPage.trim().toLowerCase() === 'post') {
				handleFilterRestore();
			}
			if (initialInputValue != filterInput) {
				sessionStorage.setItem("PostFilter", JSON.stringify(filterInput));
			} else {
				sessionStorage.removeItem("PostFilter");
			}
			dispatch(messageBoardAction.messageBoardGetPostByFilter(filterInput));
			dispatch(messageBoardAction.messageBoardGetReportType());
		} else if (tokenstr === "alerts") {
			setIsAlert(true);
			dispatch(messageBoardAction.messageBoardGetAlert(filterInput));
		} else if (tokenstr === "report") {
			setIsAlert(true);
			var input = filterInput
			input.messageBoardId = 0,
			input.topicId = 0,
			input.messageId = id
			dispatch(messageBoardAction.messageBoardGetAlert(input));
		}
		setLoggedUserId(getLoggedUserId());
		setShowModal(true);
	}, [filterInput]);

	const history = useHistory();

	const handleBackClick = (event) => {
		event.preventDefault();		
		history.goBack();
	}

	if (messageBoardData && messageBoardData.isSuccess) {
		if (messageBoardData.isPostsLoaded) {
			if (messageBoardData.postsData) {
				setPostsList(messageBoardData.postsData.posts);
				callback(messageBoardData.postsData.topicName, messageBoardData.postsData.isTopicDeleted);
				setMessage({
					...message,
					message: messageBoardData.postsData.messageBodyHtml,
					author: messageBoardData.postsData.author,
					displayName: messageBoardData.postsData.displayName,
					authorId: messageBoardData.postsData.authorId,
					authorImageUrl: messageBoardData.postsData.avatarUrlUploaded || messageBoardData.postsData.avatarImageUrl,
					messageDate: messageBoardData.postsData.createdAtUtc,
					messageId: messageBoardData.postsData.topicId,
					isMessageDeleted: messageBoardData.postsData.isTopicDeleted,
					messageReportCount: messageBoardData.postsData.topicReportCount,
					attachment: messageBoardData.postsData.attachment,
					uniqueCode: messageBoardData.postsData.uniqueCode
				})				
				var total: number = messageBoardData.postsData.totalCount;
				var pList: number[] = [];
				if (total > initialInputValue.pageSize) {
					for (var i = 1; i <= (total / initialInputValue.pageSize); i++) {
						pList.push(i);
					}
					if ((total % initialInputValue.pageSize) > 0) {
						pList.push((parseInt((total / initialInputValue.pageSize).toString()) + 1));
					}
				}
				else {
					pList.push(1);
				}
				setPageList(pList);
			}
			messageBoardData.isPostsLoaded = false;
			setShowModal(false);
		}

		if (messageBoardData.isAlertsLoaded) {
			if (messageBoardData.alertsData) {
				setAlertsList(messageBoardData.alertsData.reportedMessages);
				callback(messageBoardData.alertsData.messageBoardTitle);
				var total1: number = messageBoardData.alertsData.totalCount;				
				var pList1: number[] = [];
				if (total1 > initialInputValue.pageSize) {
					for (var i1 = 1; i1 < (total1 / initialInputValue.pageSize); i1++) {
						pList1.push(i1);
					}
					if ((total1 % initialInputValue.pageSize) > 0) {
						pList1.push((parseInt((total1 / initialInputValue.pageSize).toString()) + 1));
					}
				}
				else {
					pList1.push(1);
				}
				setPageList(pList1);
			}
			messageBoardData.isAlertsLoaded = false;
			setShowModal(false);
		}

		if (messageBoardData.isMsgReportTypesLoaded) {
			if (messageBoardData.reportTypeResults) {
				var list = [] as any;
				list.push({ text: "Select", value: -1 });
				messageBoardData.reportTypeResults.forEach((data) => {
					var item = { text: data.title, value: data.reportTypeId, checked: true };
					list.push(item);
				});
				setReportTypeList(list);
				messageBoardData.isMsgReportTypesLoaded = false;
			}
		}
	}

	if (selectedId >= -1 && messageBoardData.isSuccess && messageBoardData.isPostDeleted && !messageBoardData.isError) {
		showAlert(messageBoardData.status, false);
		messageBoardData.isSuccess = false;
		messageBoardData.isPostDeleted = false;
		dispatch(messageBoardAction.messageBoardGetPostByFilter(filterInput));
		setSelectedId(-1);
		setShowModal(false);
	}

	if (selectedId >= -1 && messageBoardData.isSuccess && messageBoardData.isTopicDeleted && !messageBoardData.isError) {
		window.localStorage.setItem('alertMessage', messageBoardData.status);
		messageBoardData.isSuccess = false;
		messageBoardData.isTopicDeleted = false;
		setSelectedId(-1);
		setShowModal(false);
		window.history.back();
	}

	if (messageBoardData && messageBoardData.isSuccess
		&& (messageBoardData.isPostRestored || messageBoardData.isTopicRestored) && !messageBoardData.isError) {
		showAlert(messageBoardData.status, false);
		messageBoardData.isSuccess = false;
		if (messageBoardData.isPostRestored)
			messageBoardData.isPostRestored = false;
		if (messageBoardData.isTopicRestored)
			messageBoardData.isTopicRestored = false;
		dispatch(messageBoardAction.messageBoardGetPostByFilter(filterInput));
		setShowModal(false);
	}

	if (messageBoardData && !messageBoardData.isSuccess && messageBoardData.isError) {
		messageBoardData.isError = false;
		messageBoardData.isPostDeleted = false;
		if (messageBoardData.status === 'Unauthorized') {
			history.push("/401");
		} else {
			showAlert(messageBoardData.status, true);
		}
		setSelectedId(-1);
		setShowModal(false);
	}

	if (messageBoardData.isSuccess && messageBoardData.isFlagSetLoaded && !messageBoardData.isError) {
		showAlert("Saved Successfully", false);
		messageBoardData.isSuccess = false;
		messageBoardData.isFlagSetLoaded = false;
		dispatch(messageBoardAction.messageBoardGetPostByFilter(filterInput));
		setIsFlagModalOpen(false);
		setShowModal(false);
	}

	if (!messageBoardData.isSuccess && !messageBoardData.isFlagSetLoaded && messageBoardData.isError) {
		messageBoardData.isError = false;
		messageBoardData.isFlagSetLoaded = false;
		showAlert(messageBoardData.status, true);
		setIsFlagModalOpen(false);
		setShowModal(false);
	}

	if (messageBoardData.isSuccess && messageBoardData.isFlagApproveOrRejectLoaded && !messageBoardData.isError) {
		showAlert("Saved Successfully", false);
		messageBoardData.isSuccess = false;
		messageBoardData.isFlagApproveOrRejectLoaded = false;
		dispatch(messageBoardAction.messageBoardGetAlert(filterInput));
		setIsFlagModalOpen(false);
		setShowModal(false);
	}

	if (messageBoardData && !messageBoardData.isSuccess && !messageBoardData.isFlagApproveOrRejectLoaded && messageBoardData.isError) {
		messageBoardData.isError = false;
		messageBoardData.isFlagApproveOrRejectLoaded = false;
		showAlert(messageBoardData.status, true);
		setIsFlagModalOpen(false);
		setShowModal(false);
	}

	const handleLoadShowModal = (value: boolean) => {
		setShowModal(value);
	};

	const handleDelete = (id: number, key: string) => {
		setSelectedId(id);
		setShowDeleteModal(true);
		setDeleteRequest(key);
	}

	const handleDeleteModal = (value: boolean, isModelClose: boolean) => {
		if (value) {
			if (deleteRequest === "message") {
				dispatch(messageBoardAction.messageBoardTopicDelete(selectedId));
			} else {
				dispatch(messageBoardAction.messageBoardPostDelete(selectedId));				
			}
			setShowModal(true);
		}
		setShowDeleteModal(false);
	};

	const handleOpenFlagModel = (id: number, isReject: boolean) => {
		if (!isReject) {
			flagObject.messageId = id;
		} else {
			flagObject.messageReportId = id;
		}
		setIsFlagModalOpen(true);		
	}

	const handleCloseFlagModal = () => {
		setIsFlagModalOpen(false);
	}

	const handleInputChange = (event) => {
		let name = event.target.name;
		let value = event.target.value;
		if (name === "report")
		{
			setFlagObject({
				...flagObject,
				messageReportTypeId: value
			});
			if (value > -1) {
				setIsTypeErr(false);
			}
		} else if (name === "note") {
			setFlagObject({
				...flagObject,
				reviewNote: value,
			});
		}
	};

	const handlePostFlagSave = () => {
		if (flagObject.messageReportTypeId < 0) {
			setIsTypeErr(true);
		}
		else
		{
			setIsTypeErr(false);
			setShowModal(true);
			flagObject.reportedByUserId = loggedUsedId;
			dispatch(messageBoardAction.messageBoardPostFlag({ reportedMessage: flagObject }));
		}
	}

	const handleSubmitApproveOrReject = (isApprove: boolean, id: number) => {
		setShowModal(true);
		flagObject.reviewedByUserId = loggedUsedId;
		flagObject.isApprove = isApprove;
		if (isApprove) {
			flagObject.messageReportId = id;
		}
		dispatch(messageBoardAction.messageBoardPostAuthorization({ reportedMessage: flagObject }));
	}

	const handleRestore = (id: number, key: string) => {
		setShowModal(true);
		if (key === 'post') {
			dispatch(messageBoardAction.messageBoardPostRestore(id))
			
		} else {
			dispatch(messageBoardAction.messageBoardTopicRestore(id))
		}
	}

	return (
		<div className="forum-post">
			<div className='card-box'>
				<DABBackToList onClick={(e) => { handleBackClick(e); }} />

				<div className='card-box'>
					<Row className='filter-link-container'>
						<Col lg="8" className='column'>
							<CardLink onClick={handleToggle} className='card-box-link'>Filter List</CardLink>
							<CardLink onClick={handleDownload} className='card-box-link'>Download Message Attachments</CardLink>
							{showClearFilter ?
								<CardLink onClick={handleFilterClear} className='card-box-link-filter'>Clear Filter</CardLink>
								: <CardLink className='card-box-link-filter-disabled'>Clear Filter</CardLink>}
						</Col>			
					</Row>
					{fadeIn && (
						<Fade in={fadeIn} tag="h5" className='card-fade'>
							<Row>
								<Col lg="4" className="filter-container-small">
									<Container className='filter-container'>
										<div className='box-container'>
											<Row>
												<Col lg="8">
													<div>
														<label>Status</label>
														<div className='filterRow'>
															<Input type="checkbox" className='box-container-input' checked={isNotDeleted}
																onChange={(e) => { setIsNotDeleted(e.target.checked) }} 
																/>
															<span>Not Deleted</span>
														</div>
														<div className='filterRow'>
															<Input type="checkbox" className='box-container-input' checked={isDeleted}
																onChange={(e) => { setIsDeleted(e.target.checked) }}
															/>
															<span>Deleted</span>
														</div>
													</div>
												</Col>
												<Col lg="4">
													<div className='close-div'>
														<FontAwesomeIcon data-bs-toggle="tooltip" data-bs-placement="bottom" size='3x'
															title="Close" icon={faTimes} onClick={handleToggle} />
													</div>
												</Col>
											</Row>
											<Row>												
												<Col lg="3">
													<Button id="submit" className="inner-filter-link" onClick={handleFilter}>Filter</Button>
												</Col>
											</Row>
										</div>
									</Container>
								</Col>
							</Row>
							
						</Fade>)}
				</div>

				{!isAlert && (message && message.messageId > 0?
					<div className={`message-container ${message.isMessageDeleted ? 'topic-inactive' : 'topic-active'}`} data-testid="massage-container">
						<div className='author-box'>
						<div className="ab-left" >
							{(message.authorImageUrl != null && message.authorImageUrl != "") ?
								<img src={message.authorImageUrl || Profile} alt="test" data-testid="messageAuthor" />:
								<FontAwesomeIcon data-testid="messageAuthor" size='2x' className='icon-m' title={message.author} icon={faUserCircle} />}
								<div className="ab-middle ">
									<a href={"/dashboard?id=" + message.authorId} className="detail-link" data-testid="messageAuthorName">{message.author} {message.displayName ? `(${message.displayName})` : ""}</a>
								<div className='post-date' data-testid="messageDate">{message.messageDate != "" ? moment(message.messageDate).format('LLL') : ""}</div>
							</div>
						</div>						
						<div className='ab-right'>
								{message.messageReportCount > 0 &&
									<a href={"/messageboard?page=report&id=" + message.messageId} className="detail-link">
									< FontAwesomeIcon data-testid="messageFlag" size='2x' className='icon-m' title="Reports" icon={faFlag} cursor='pointer' /></a>}
							{!message.isMessageDeleted ? < FontAwesomeIcon data-testid="messageDelete" size='2x' className='icon-m' title="Delete" icon={faTrashAlt} cursor='pointer'
									onClick={() => { handleDelete(message.messageId, "message") }} /> :
									<FontAwesomeIcon id={"restoreIcon" + message.messageId} cursor='pointer' size='2x' icon={faRecycle} title="Restore"
										onClick={() => { handleRestore(message.messageId, "topic"); }} />}
							</div>
						</div>
					<div className='post-message' data-testid="messageContent">
						{/* <ReactReadMoreReadLess
							charLimit={480}
							readMoreText={"Read more ▼"}
							readLessText={"Read less ▲"}
							readMoreClassName="read-more"
							readLessClassName="read-more-less"
						>{message.message}
						</ReactReadMoreReadLess> */}
						<div dangerouslySetInnerHTML={{ __html: message.message }} />
					</div>
					</div> :
					<h6 className="text-center mt-5">No data found</h6>)}
			</div>
			<div className='card-box'>
				{ !isAlert && postsList && postsList.length > 0 &&
					postsList && postsList.map((data: any,index) =>
						<Container data-testid={"postContainer" + data.postId} key={data.postId} className={`filter-container ${data.isDeleted?'post-inactive':'post-active'}`}>
							<div data-testid="postContainerDiv" className='box-container-topic'>
								<div data-testid="postContainerCloseDiv" className='close-div'>								
									{data.reportedCount > 0 ?
										<a href={"/messageboard?page=report&id=" + data.postId} className="detail-link">
										<FontAwesomeIcon data-testid="postFlag" size='2x' className='icon-m' title="Reports" icon={faFlag} cursor='pointer'
										onClick={() => {sessionStorage.setItem("postFromPage", "post")}}/></a>:""}
									{!data.isDeleted ? <FontAwesomeIcon data-testid="postDelete" size='2x' className='icon-m' title="Delete" icon={faTrashAlt} cursor='pointer'
										onClick={() => { handleDelete(data.postId, "reply"); }} /> :
										<FontAwesomeIcon data-testid="postRestore" cursor='pointer' size='2x' className='icon-m' icon={faRecycle} title="Restore"
											onClick={() => { handleRestore(data.postId,"post") } } />}
								</div>

								<CardImg data-testid="postImage" height="50" width="50" className='card-box-img-small'
									src={data.avatarUrlUploaded || data.avatarImageUrl || Profile}
									alt="test" onError={(e: any) => { e.target.src = Profile }} />
								<div data-testid="S" className='post-box'>
									<a href={"/dashboard?id=" + data.authorId} className="detail-link" data-testid={"authorLink" + index}>
										{data.author} {data.displayName ? `(${data.displayName})` : ""}
									</a>
								</div>
								<div data-testid="postCreatedAtUtc" className='post-date'>
									{moment(data.createdAtUtc).format('LLL')}
								</div>
								<div data-testid="postDesc" className='post-desc'>
									<ReactReadMoreReadLess
										charLimit={250}
										readMoreText={"Read more ▼"}
										readLessText={"Read less ▲"}
										readMoreClassName="read-more"
										readLessClassName="read-more-less"
									>{data.messageBodyHtml}
									</ReactReadMoreReadLess>
								</div>
							</div>
						</Container>
					) }

				{ isAlert && messageBoardData && messageBoardData.alertsData &&
					messageBoardData.alertsData.reportedMessages &&
					messageBoardData.alertsData.reportedMessages.map((data: any, index: number) =>
						<Container data-testid={"postContainer" + data.reportedMessageId} key={data.reportedMessageId} className={`filter-container ${data.isDeleted ? 'post-inactive' : 'post-active'}`}>
						<div className='box-container-topic'>							
							<CardImg data-testid="postImage" height="50" width="50" className='card-box-img-small'
								src={(data.avatarImageUrl != null && data.avatarImageUrl != "") ? data.avatarImageUrl : Profile}
								alt="test" onError={(e: any) => { e.target.src = Profile }}
								/>
								<div data-testid={"postAuthor" + index} className='post-box'>
									<a href={"/dashboard?id=" + data.authorId} className="detail-link" data-testid={"authorLink"}>{data.author} {data.displayName ? `(${data.displayName})` : "" }</a>
							</div>
								<div data-testid="postCreatedAtUtc" className='post-date'>{moment(data.createdAtUtc).format('LLL')}</div>
								<div data-testid={"postDesc" + index} className='post-desc'>
								<ReactReadMoreReadLess
									charLimit={250}
									readMoreText={"Read more ▼"}
									readLessText={"Read less ▲"}
									readMoreClassName="read-more"
									readLessClassName="read-more-less"
								>{data.messageBodyHtml}
								</ReactReadMoreReadLess>
							</div>
							{data.messageType == "post" &&
									<div className="parrent-subject">
									<div data-testid="lblinreplyTo">In Reply to : </div><h6><a href={"/messageboard?page=posts&id=" + data.topicId} data-testid="replylink" className="detail-link">{data.topicName}</a></h6>
							</div>
							}
							{data.messageType == "topic" &&
								<div className="parrent-subject">
									<div data-testid="lblSubject">Subject : </div><h6><a href={"/messageboard?page=posts&id=" + data.topicId} data-testid="subjectlink"className="detail-link">{data.topicName}</a>
									</h6>
								</div>
							}
						</div>
						<div className="box-footer">
							<div className="report-container post-active">
							{messageBoardData && messageBoardData.alertsData &&
								messageBoardData.alertsData.reportedMessages &&
								messageBoardData.alertsData.reportedMessages[index].reportedMessagesInfo.map((msg: any) =>
								<div className="report-box">
									<div className="rb-row">
										<div className="rbr-left">
											<div className="rpt-left">
												<CardImg data-testid="reportedImage" height="50" width="50" className='card-box-img-small'
													src={msg.avatarUrlUploaded || msg.avatarImageUrl || Profile}
													alt="test" onError={(e: any) => { e.target.src = Profile }}/>
											</div>
											<div className="rpt-right">
													<div data-testid="reportedBy" className='reported-by'>
														<a href={"/dashboard?id=" + msg.reportedById} className="detail-link" data-testid={"authorLink1" + index}>{msg.reportedBy} {msg.reportedByDisplayName ? `(${msg.reportedByDisplayName})` : "" }</a>
												</div>
												<div data-testid="reportedAt" className="reported-at"> {moment(msg.reportedAtUtc).format('LLL')} </div>
											</div>
										</div>
										{!data.isDeleted && 
												<div className='close-div'>
													<FontAwesomeIcon data-testid="postFlagApprove" size='2x' className='icon-m' title="Approve Alert" icon={faCheckCircle} cursor='pointer'
														onClick={() => { handleOpenFlagModel(msg.messageReportId, true) }}/>
													<FontAwesomeIcon data-testid="postFlagReject" size='2x' className='icon-m' title="Reject Alert" icon={faTimesCircle} cursor='pointer'
														onClick={() => { handleSubmitApproveOrReject(true, msg.messageReportId) }}/>
												</div> }
									</div>
									<div className="rb-row"><div data-testid="reportedNote" className="reported-note">{msg.reportNote}</div></div>
									<div className="rb-row">
										<div data-testid="reportedType" className="rbr-left"><div className="reported-type">{msg.reportTypeName}</div></div>
									</div>
									</div>)}
							</div>
						</div>
					</Container>
				)}
				<div className="pagination">
					<ReactPaginate
						previousLabel={'<<'}
						nextLabel={'>>'}
						breakLabel={'...'}
						pageCount={pageList.length}
						marginPagesDisplayed={2}
						pageRangeDisplayed={5}
						onPageChange={handlePageClick}
						forcePage={currentPageNo}
						containerClassName={'pagination'}
						pageClassName={"page-item"}
						previousClassName={"page-item"}
						breakClassName={"page-item"}
						breakLinkClassName={"page-link"}
						nextClassName={"page-item"}
						pageLinkClassName={"page-link"}
						previousLinkClassName={"page-link"}
						nextLinkClassName={"page-link"}
						activeClassName={'active'}
					/>
				</div>
			</div>
			{
				showModal && (
					<LoadingSpinnerModal isShowModal={showModal} modalChange={handleLoadShowModal} />
				)
			}
			<ConfirmModal isShowModal={showDeleteModal}
				deleteMessage={deleteRequest === "message" ?
					"Deleting a message will delete the message and all replies. Are you sure you want to do this? " :
					"Are you sure you want to delete this reply?"} modalChange={handleDeleteModal} />

			<Modal isOpen={isFlagModalOpen} backdrop="static" centered>
				<ModalBody className="modal-body">
					<form name="createform">
						{!isAlert && <div className={["row mb-3"].join(" ")}>
							<label htmlFor="report" className={["col-sm-2 col-form-label"].join(" ")}>Reason</label>
							<div data-testid="flagReportType" className={["col-sm-5"].join(" ")}>
								<DABDropDown id="report" value={flagObject.messageReportTypeId}
									isRequired={true} isHover={false}
									onChange={(event) => { handleInputChange(event); }} options={reportTypeList} />
  								   <div style={{ display: `${isTypeErr ? '' : 'none'}` }} data-testid="typeErrContainer"><label data-testid="typeErr" className="text-danger">Please Select Reason</label></div>
							</div>
						</div>
						}
						<div className={["row mb-3"].join(" ")}>
							<label htmlFor="note" className={["col-sm-2 col-form-label"].join(" ")}>Note</label>
							<div data-testid="flagReportNote" className={["col-sm-5"].join(" ")}>
								<DABTextBox type="textarea" id="note" isHover={false}
									onChange={(event) => { handleInputChange(event) }} value={flagObject.reviewNote} />
							</div>
						</div>
					</form>
				</ModalBody>
				<ModalFooter>
					<button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={handleCloseFlagModal} >UNDO</button>
					<button type="button" className="btn btn-primary" onClick={() => {
						!isAlert ? handlePostFlagSave() : handleSubmitApproveOrReject(false, 1)
					}}
					>OK</button>
				</ModalFooter>
			</Modal>
		</div>
	);
};


const mapStateToProps = (state: any) => {
	const { messageBoardData } = state;
	return {
		messageBoardData
	};
};

export default connect(mapStateToProps)(Posts);